import React from "react";
import { TYPE_OPTIONS, YEAR_OPTIONS } from "@/constants/options";

export default function FilterBar({ type, setType, year, setYear }) {
  return (
    <div className="space-y-5" data-testid="filter-bar">
      <div>
        <h4 className="font-display text-xs uppercase tracking-[0.2em] font-bold text-zinc-600 mb-3">
          Opportunity Type
        </h4>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            className={`brut-chip ${type === "" ? "brut-chip-active" : "brut-chip-inactive"}`}
            onClick={() => setType("")}
            data-testid="filter-type-all"
          >
            All
          </button>
          {TYPE_OPTIONS.map((t) => (
            <button
              type="button"
              key={t.value}
              className={`brut-chip ${type === t.value ? "brut-chip-active" : "brut-chip-inactive"}`}
              onClick={() => setType(t.value)}
              data-testid={`filter-type-${t.value}`}
              style={type === t.value ? { backgroundColor: t.color, color: "#0A0A0A" } : {}}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <div>
        <h4 className="font-display text-xs uppercase tracking-[0.2em] font-bold text-zinc-600 mb-3">
          Year Group
        </h4>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            className={`brut-chip ${year === "" ? "brut-chip-active" : "brut-chip-inactive"}`}
            onClick={() => setYear("")}
            data-testid="filter-year-all"
          >
            All Years
          </button>
          {YEAR_OPTIONS.map((y) => (
            <button
              type="button"
              key={y.value}
              className={`brut-chip ${year === y.value ? "brut-chip-active" : "brut-chip-inactive"}`}
              onClick={() => setYear(y.value)}
              data-testid={`filter-year-${y.value}`}
            >
              {y.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
